export interface ProductPromotionsFeatureRoutesConfig {
  path: string;
}

export const defaultProductPromotionsFeatureRoutesConfig: ProductPromotionsFeatureRoutesConfig = {
  path: 'promotions',
};
